export const PIN_COLOR_OPTIONS = [
    { value: 'error', label: 'Red', color: '#D92D20' },
    { value: 'primary', label: 'Blue', color: '#1570EF' },
    { value: 'warning', label: 'Orange', color: '#F79009' },
    { value: 'success', label: 'Green', color: '#12B76A' },
    { value: 'secondary', label: 'Purple', color: '#7A5AF8' },
];

export const DEFAULT_PIN_COLOR = 'error';
export const DEFAULT_PIN_HEX = PIN_COLOR_OPTIONS[0].color;

export const getPinColor = (value) =>
    PIN_COLOR_OPTIONS.find((option) => option.value === value)?.color || DEFAULT_PIN_HEX;
